import React, { useEffect } from 'react';
import LoginWrap from '../UI/LoginWrap';

function GetApp() {
  const { qr } = styles;

  return (
    <LoginWrap>
      <div style={styles.container}>
        <h1 style={styles.header}>Welcome to ProductLab</h1>
        <p>Scan this QR to get the app!</p>
        <img src="/get_app_qr.png" style={qr} />
      </div>
    </LoginWrap>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column'
  },
  header: {
    font: "40px/48px 'Domine', serif",
    color: '#333646',
    margin: 0,
    fontWeight: 70
  },
  qr: {
    width: 200,
    marginTop: 20
  }
};

export default GetApp;
